import { MailCheck, MailWarning, Bot } from "lucide-react";

const short = (iso) => {
  const d = iso ? new Date(iso) : null;
  return d && !isNaN(d) ? `${d.getMonth() + 1}/${d.getDate()}` : "";
};
const long = (iso) => {
  const d = iso ? new Date(iso) : null;
  return d && !isNaN(d) ? d.toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" }) : "";
};
const lastNote = (c) => c.last_email_note || (c.history || []).filter((h) => h.type === "email").slice(-1)[0]?.subject || "";

export const wasEmailed = (c) => (c.email_count || 0) > 0;

export function EmailedChip({ card, testId }) {
  const n = card.email_count || 0;
  if (n > 0) {
    return (
      <span data-testid={testId} title={`Emailed ${n}× — last ${long(card.last_emailed_at)}${card.last_emailed_by ? ` by ${card.last_emailed_by}` : ""}`}
        className="inline-flex items-center gap-1 text-[9px] font-extrabold uppercase tracking-[0.12em] px-1.5 py-0.5 rounded bg-[#1E73C9]/10 text-[#1E73C9] shrink-0">
        <MailCheck className="h-2.5 w-2.5" /> Emailed{n > 1 ? ` ${n}×` : ""} · {short(card.last_emailed_at)}
      </span>
    );
  }
  if (!card.auto_reply_at) return null;
  return (
    <span data-testid={testId} title={`Website auto-reply sent ${long(card.auto_reply_at)} — no personal email yet`}
      className="inline-flex items-center gap-1 text-[9px] font-extrabold uppercase tracking-[0.12em] px-1.5 py-0.5 rounded bg-[#15233B]/8 text-[#15233B]/55 shrink-0">
      <Bot className="h-2.5 w-2.5" /> Auto-reply · {short(card.auto_reply_at)}
    </span>
  );
}

export function EmailedWarning({ contact }) {
  const n = contact.email_count || 0;
  if (n > 0) {
    const note = lastNote(contact);
    return (
      <div data-testid="send-email-already-emailed" className="flex gap-2 text-xs text-[#7a5a1a] bg-[#FFF9C4] border border-[#FFCB05]/60 rounded px-2.5 py-2">
        <MailWarning className="h-4 w-4 shrink-0 text-[#b45309]" />
        <span>
          <b>Already emailed {n === 1 ? "once" : `${n} times`}</b> — last on {long(contact.last_emailed_at)}{contact.last_emailed_by ? ` by ${contact.last_emailed_by}` : ""}.
          {note && <span className="block text-[#7a5a1a]/80 truncate" title={note}>{note}</span>}
        </span>
      </div>
    );
  }
  if (!contact.auto_reply_at) return null;
  return (
    <div data-testid="send-email-auto-reply-only" className="flex gap-2 text-xs text-[#15233B]/65 bg-[#15233B]/5 border border-[#15233B]/10 rounded px-2.5 py-2">
      <Bot className="h-4 w-4 shrink-0" />
      <span>Website auto-reply sent {long(contact.auto_reply_at)}. This will be the first personal email.</span>
    </div>
  );
}
